import { resolveChatMessagePayloadToText } from "../ChatBotMessage";
import { WebChatBotMessageDto } from "./WebChatBotMessageDto";
import { WebChatBotMessageModel } from "./WebChatBotMessageModel";

export const transformWebChatBotMessageDtoToModel = (
  dto: WebChatBotMessageDto
): WebChatBotMessageModel => {
  return {
    ...dto,
    payload: {
      text: resolveChatMessagePayloadToText(dto.payload),
      timestamp: dto.payload.timestamp ?? 0,
      type: "text",
    },
  };
};
